import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const UploadCsvStat = ({ code, caption, endpoint, handleSubmit }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [ignoreHeaderRow, setIgnoreHeaderRow] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) {
      setError("Seleziona un file");
      return;
    }

    setError(null);
    setFile(selectedFile);
  };

  const doSubmit = (e, format) => {
    e.preventDefault();

    if (!file) {
      setError("Seleziona un file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("reportCode", code);
    formData.append("ignoreHeaderRow", ignoreHeaderRow.toString()); //accetta solo string o Blob

    handleSubmit(e, endpoint, formData, format);
  };

  return (
    <div className="container my-5">
      <div className="card p-3">
        <h5 className="card-title">{caption}</h5>

        <form>
          <div className="row align-items-end">
            <div className="col-md-6 mb-3 position-relative">
              <input
                type="file"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                accept=".csv"
                onChange={handleFileChange}
              />


              <div className="form-check mt-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="ignoreHeaderRow"
                  checked={ignoreHeaderRow}
                  onChange={(e) => setIgnoreHeaderRow(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="ignoreHeaderRow">
                  Ignora prima riga (header)
                </label>
              </div>

              {error && <div className="invalid-tooltip">{error}</div>}
            </div>

            <div className="col-md-6 mb-3 text-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => doSubmit(e, 'csv')}
              >
                <FontAwesomeIcon icon="download" />
                Scarica
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadCsvStat;